import React from 'react';

import { List } from 'antd';
import styled from 'styled-components';

import CommunitiesListHeader from './CommunitiesListHeader';
import CommunityListItem from './CommunityListItem';
import Pagination from './Pagination';
import { useSettingsContext } from './SettingsContext';
import SettingsToolbar from './SettingsToolbar';

const Container = styled.div`
  padding: 15px 30px;
  border-top: 1px solid var(--line-gray);
`;

const StyledList = styled(List)`
  && .ant-list-item:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  && .ant-list-item:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

type Props = {
  hideFilters?: boolean;
  selectPopupWidth?: number;
  statusFilterWidth?: number;
  extraHeaders?: string[];
  renderExtraColumns?: (item: any) => React.ReactNode[];
  toggleMultipleSelection: () => void;
  modifyCommunity: (c: any) => void;
  setPage: (i: number) => void;
  setSearchTerm: (i: string) => void;
  setStatus: (i: number | null) => void;
};

const CommunitiesList = ({
  hideFilters = false,
  selectPopupWidth,
  statusFilterWidth,
  extraHeaders = [],
  renderExtraColumns,
  toggleMultipleSelection,
  modifyCommunity,
  setPage,
  setSearchTerm,
  setStatus,
}: Props) => {
  const { communities, selectedCommunitiesIds, loadingCommunities } = useSettingsContext();

  return (
    <Container>
      <SettingsToolbar
        selectPopupWidth={selectPopupWidth}
        statusFilterWidth={statusFilterWidth}
        hideFilters={hideFilters}
        toggleMultipleSelection={toggleMultipleSelection}
        setSearchTerm={setSearchTerm}
        setStatus={setStatus}
        setPage={setPage}
      />
      <div>
        <CommunitiesListHeader extraHeaders={extraHeaders} />
        <div>
          <StyledList
            bordered
            loading={loadingCommunities}
            dataSource={communities}
            renderItem={(item: any) => (
              <CommunityListItem
                key={item.id}
                item={item}
                renderExtraColumns={renderExtraColumns}
                isSelected={selectedCommunitiesIds.some((el: any) => el === item.id)}
                onClick={modifyCommunity}
              />
            )}
          />
          <Pagination setPage={(page: number) => setPage(page)} />
        </div>
      </div>
    </Container>
  );
};

export default CommunitiesList;
